export const validateForm = {
  required: 'Это поле необходимо заполнить',
  email: 'Неверный формат Email',
}
